import apis from "../../../../api";
import { errorTypes } from "../../../../utils/errorTypes";
import { setRolesAndPermissionsAction } from "../../actionCreators/adminActionCreator/rolesAndPermissionsActionCreator";
import loaders from "../../actionCreators/loadersActionCreator";
import { setErrorHandler } from "../errorActionHandler";

export const getRolesAndPermissionsActionHandler =
  (
    searchText,
    pageNumber,
    pageSize,
    setRolesAndPermissionsData,
    setTempRolesAndPermissionsData,
    setTotalRows
  ) =>
  async (dispatch) => {
    await apis.admin.rolesAndPermissions
      .getRolesAndPernissions()
      .then((response) => {
        if (response) {
          setRolesAndPermissionsData(response?.data?.lstpermissions);
          setTempRolesAndPermissionsData(response?.data?.lstpermissions);
          setTotalRows(response?.data?.lstpermissions?.length);
          dispatch(setRolesAndPermissionsAction(response?.data));
        } else
          dispatch(
            setErrorHandler(
              errorTypes.FAIL,
              "Roles And Permissions Loading Failed"
            )
          );
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const postRoleMenuMappingActionHandler =
  (data, refreshTable) => async (dispatch) => {
    dispatch(loaders.admin.rolesAndPermissions.postRoleLoader(true));
    await apis.admin.rolesAndPermissions
      .postRoleMenuMapping(data)
      .then((response) => {
        if (response.data) {
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              "Roles And Permissions Saved Successfully"
            )
          );
          refreshTable();
        } else
          dispatch(
            setErrorHandler(
              errorTypes.FAIL,
              "Roles And Permissions Saving Failed"
            )
          );
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(loaders.admin.rolesAndPermissions.postRoleLoader(false));
      });
  };

export const createRoleActionHandler = (data) => async (dispatch) => {
  return await apis.admin.rolesAndPermissions
    .createRole(data)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const checkRoleNameActionHandler = (name) => async () => {
  return await apis.admin.rolesAndPermissions
    .checkRoleName(name)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};
